import './process.env.js';
import './heap/heapTrack';
import './intercom/intercom';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, Provider as RollbarProvider } from '@rollbar/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { OidcProvider } from '@preqin/preqin-core/cjs/OIDC/oidc.utils';

// OIDC components
import { Auth, AuthError, CallbackSuccess, Loading, ServiceWorkerNotSupported, SessionLost } from './components/oidc';
import { configurationOidc } from './config/auth/oidcConfig';
import App from './App';
import reportWebVitals, { sendToAnalytics } from './reportWebVitals';
import { rollbarInstance } from './rollbarConfig';

//Container Styles
import './index.scss';
import './App.module.scss';

const queryClient = new QueryClient();

const mountElement = document.querySelector('#root');
const root = createRoot(mountElement);

root.render(
  <RollbarProvider config={rollbarInstance}>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <OidcProvider
          configuration={configurationOidc}
          loadingComponent={Loading}
          sessionLostComponent={SessionLost}
          authenticating={Auth}
          authenticatingErrorComponent={AuthError}
          callbackSuccessComponent={CallbackSuccess}
          serviceWorkerNotSupportedComponent={ServiceWorkerNotSupported}
        >
          <App />
        </OidcProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </RollbarProvider>,
);

if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
} else {
  //Send metrics to analytics service
  reportWebVitals(sendToAnalytics);
}
